import { motion } from "framer-motion";
import Logo from "./Logo";
import Wordmark from "./Wordmark";

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[300] bg-ink flex flex-col items-center justify-center gap-6"
      initial={{ opacity: 1 }}
      exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <Logo className="w-14 h-14" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.15 }}
      >
        <Wordmark className="h-5 w-auto text-cream/90" />
      </motion.div>
      <motion.div
        className="h-px bg-brass/60 origin-left"
        initial={{ width: 0 }}
        animate={{ width: 120 }}
        transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.div
        data-testid="preloader-slogan"
        className="text-[10px] uppercase tracking-[0.3em] text-stone/70 leading-none"
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
      >
        your home, our care.
      </motion.div>
    </motion.div>
  );
}
